import React from "react";

import { Button, Img, PagerIndicator, Text } from "components";

const CategoryFeatureProducts = (props) => {
  return (
    <>
      <div className={props.className}>
        <div className="h-[620px] relative w-1/2 md:w-full">
          <Img
            className="h-[620px] m-auto object-cover rounded-[10px] w-full"
            src="images/img_unsplashvxhpxyqocfq.png"
            alt="unsplashvxhpxyq"
          />
          <div className="absolute bg-gradient  flex flex-col h-full inset-[0] items-center justify-center m-auto p-5 rounded-[10px] w-full">
            <PagerIndicator
              className="flex gap-1 h-5 md:h-auto items-start justify-between mt-[559px] w-[77px]"
              count={4}
              activeCss="inline-block cursor-pointer rounded-[50%] h-2 bg-indigo-A700_01 w-2"
              activeIndex={1}
              inactiveCss="inline-block cursor-pointer rounded-[50%] h-2 bg-gray-300 w-2"
              selectedWrapperCss="inline-block"
              unselectedWrapperCss="inline-block"
            />
          </div>
        </div>
        <div className="flex flex-col gap-5 items-center justify-start w-1/2 md:w-full">
          <div className="bg-white-A700 flex flex-col items-center justify-start p-[27px] sm:px-5 rounded-lg w-full">
            <div className="flex sm:flex-col flex-row gap-[15px] items-center justify-start my-[3px] w-full">
              <div className="flex sm:flex-1 flex-col items-start justify-start w-3/5 sm:w-full">
                <Text
                  className="text-black-900_dd text-xl tracking-[0.15px]"
                  size="txtInterMedium20"
                >
                  {props?.productname}
                </Text>
                <Text
                  className="leading-[24.00px] mt-3.5 text-base text-black-900_dd tracking-[0.50px] w-full"
                  size="txtInterRegular16"
                >
                  {props?.productdescription}
                </Text>
                <div className="flex flex-col items-start justify-start mt-[17px] w-[67%] md:w-full">
                  <div className="flex flex-row items-start justify-start w-[52%] md:w-full">
                    <Text
                      className="text-blue_gray-700 text-xs tracking-[0.40px]"
                      size="txtInterRegular12"
                    >
                      {props?.price}
                    </Text>
                    <Text
                      className="ml-[3px] text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterMedium20"
                    >
                      {props?.productprice}
                    </Text>
                  </div>
                  <Text
                    className="text-black-900_99 text-xs tracking-[0.25px]"
                    size="txtInterRegular12Black90099"
                  >
                    {props?.bodytwo}
                  </Text>
                </div>
                <Button
                  onClick={props?.setShowDialog}
                  className="cursor-pointer flex items-center justify-center min-w-[162px] mt-[53px]"
                  leftIcon={
                    <Img
                      className="h-6 mr-[5px]"
                      src="images/img_visibility.svg"
                      alt="Visibility"
                    />
                  }
                  shape="circle"
                  color="indigo_A700"
                  size="xs"
                  variant="fill"
                >
                  <div className="font-inter text-left text-sm tracking-[0.25px]">
                    {props?.takequicklook}
                  </div>
                </Button>
              </div>
              <Img
                className="sm:flex-1 h-[136px] md:h-auto object-cover w-[39%] sm:w-full"
                src="images/img_rectangle17.png"
                alt="rectanglesevent"
              />
            </div>
          </div>
          <div className="bg-white-A700 flex flex-col items-center justify-start p-[27px] sm:px-5 rounded-lg w-full">
            <div className="flex sm:flex-col flex-row gap-[15px] items-center justify-start my-[3px] w-full">
              <div className="flex sm:flex-1 flex-col items-start justify-start w-3/5 sm:w-full">
                <Text
                  className="text-black-900_dd text-xl tracking-[0.15px]"
                  size="txtInterMedium20"
                >
                  {props?.productnameone}
                </Text>
                <Text
                  className="leading-[24.00px] mt-3.5 text-base text-black-900_dd tracking-[0.50px] w-full"
                  size="txtInterRegular16"
                >
                  {props?.productdescriptionone}
                </Text>
                <div className="flex flex-col items-start justify-start mt-[17px] w-[67%] md:w-full">
                  <div className="flex flex-row items-start justify-start w-[52%] md:w-full">
                    <Text
                      className="text-blue_gray-700 text-xs tracking-[0.40px]"
                      size="txtInterRegular12"
                    >
                      {props?.priceone}
                    </Text>
                    <Text
                      className="ml-[3px] text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterMedium20"
                    >
                      {props?.productpriceone}
                    </Text>
                  </div>
                  <Text
                    className="text-black-900_99 text-xs tracking-[0.25px]"
                    size="txtInterRegular12Black90099"
                  >
                    {props?.bodytwoone}
                  </Text>
                </div>
                <Button
                  onClick={props?.setShowDialog}
                  className="cursor-pointer flex items-center justify-center min-w-[162px] mt-[53px]"
                  leftIcon={
                    <Img
                      className="h-6 mr-[5px]"
                      src="images/img_visibility.svg"
                      alt="Visibility"
                    />
                  }
                  shape="circle"
                  color="indigo_A700"
                  size="xs"
                  variant="fill"
                >
                  <div className="font-inter text-left text-sm tracking-[0.25px]">
                    {props?.takequicklookone}
                  </div>
                </Button>
              </div>
              <Img
                className="sm:flex-1 h-[136px] md:h-auto object-cover w-[39%] sm:w-full"
                src="images/img_rectangle17.png"
                alt="rectanglesevent_One"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

CategoryFeatureProducts.defaultProps = {
  productname: "Haier Google TV 55",
  productdescription: (
    <>
      SmartTV with google operating system. <br />
      HDR, UHD
    </>
  ),
  price: "TZS",
  productprice: "990,000",
  bodytwo: "Only few remains in stock order now",
  takequicklook: "Take quick look",
  productnameone: "Haier Google TV 55",
  productdescriptionone: (
    <>
      SmartTV with google operating system. <br />
      HDR, UHD
    </>
  ),
  priceone: "TZS",
  productpriceone: "560,000",
  bodytwoone: "Only few remains in stock order now",
  takequicklookone: "Take quick look",
};

export default CategoryFeatureProducts;
